/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import {
  formatCurrency,
  formatDate,
  getNewDate,
} from '../../../shared/helper-utils/appUtils';
import { DATE_MONTH_YEAR_VIEW_FORMAT } from '../../../shared/constants/Constants';
import { getValueFromAppConfig } from '../../../shared/helper-utils/localStorage';

function LedgerTable({ fromDate, toDate, ledgerRows, onSort }) {
  const intl = useIntl();

  const isCustomLedger = getValueFromAppConfig('SHOW_CUSTOM_LEDGER') === 'true';

  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const getPaymentMode = (narration = '') => {
    const match = narration.match(/PaymentMode:([^_]+)/i);
    return match ? match[1].toLowerCase() : '';
  };
  return (
    <section className="p-3 table-label">
      <div className="app-container overflow-auto">
        {formattedMessage('from')}{' '}
        <span className="value">
          {formatDate(getNewDate(fromDate), DATE_MONTH_YEAR_VIEW_FORMAT)}
        </span>{' '}
        {formattedMessage('to')}{' '}
        <span className="value">
          {formatDate(getNewDate(toDate), DATE_MONTH_YEAR_VIEW_FORMAT)}
        </span>
        <table className="ledger-table w-100 mt-3 table-bordered">
          <thead>
            <tr>
              <td onClick={onSort} className="cursor-pointer">
                {formattedMessage('date')}
              </td>
              <td>Deposit Date</td>
              <td>{formattedMessage('type')}</td>
              <td>{formattedMessage('reference')}</td>
              <td>{formattedMessage('debit')}</td>
              <td>{formattedMessage('credit')}</td>
              <td>{formattedMessage('balance')}</td>
            </tr>
          </thead>
          <tbody>
            {ledgerRows.map((row) => {
              const paymentMode = getPaymentMode(row.Narration);

              // Only activate split-row display when SHOW_CUSTOM_LEDGER is true
              // AND the booking is a non-cashcard hotel/flight booking
              const shouldShowZero =
                isCustomLedger &&
                (row.TxType === 'HOTELBKG' || row.TxType === 'FLTBKG') &&
                paymentMode &&
                paymentMode !== 'cashcard';

              return (
                <React.Fragment key={row.TxReference}>
                  <tr>
                    <td>{row.TxDate}</td>
                    <td>{row.TravelDate}</td>
                    <td>{row.TxType}</td>
                    <td>
                      <div>{row.TxReference}</div>
                    </td>
                    {/* Debit */}
                    <td className="value">
                      {shouldShowZero ? (
                        <div>
                          <div>{formatCurrency('0.00')}</div>
                          <div
                            style={{
                              borderTop: '1px solid #d3d3d3',
                              marginTop: '4px',
                              paddingTop: '4px',
                            }}
                          >
                            {formatCurrency(Math.abs(row.Debit).toFixed(2))}
                          </div>
                        </div>
                      ) : (
                        formatCurrency(Math.abs(row.Debit).toFixed(2))
                      )}
                    </td>

                    {/* Credit */}
                    <td className="value">
                      {shouldShowZero ? (
                        <div>
                          <div>{formatCurrency(row.Credit.toFixed(2))}</div>

                          <div
                            style={{
                              borderTop: '1px solid #d3d3d3',
                              marginTop: '4px',
                              paddingTop: '4px',
                            }}
                          >
                            {formatCurrency('0.00')}
                          </div>
                        </div>
                      ) : (
                        formatCurrency(row.Credit.toFixed(2))
                      )}
                    </td>
                    <td>{formatCurrency(row.Balance.toFixed(2))}</td>
                  </tr>
                  <tr>
                    <td colSpan={7}>
                      <div className="fs-14 secondary-text">
                        {row.Narration}
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

LedgerTable.propTypes = {
  ledgerRows: PropTypes.array.isRequired,
  fromDate: PropTypes.string.isRequired,
  toDate: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
};

export default LedgerTable;
